import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FormType } from '@/api/enum/formType.enum';
import { use, useState } from 'react';
import InterventionForm from './components/InterventionForm';
import { useGetInterventionDetailQuery } from '@/api/member-management/intervention';
import { useParams } from 'react-router-dom';
import AppFieldView from '@/common/components/form-view/AppFieldView';

export default function EditCaseNotePage() {
	const { t } = useTranslation();
	const [type, setType] = useState<FormType>(FormType.edit);
	// This page is a child of the intervention detail route, so the intervention
	// id comes from the parent route param.
	const { interventionId } = useParams();

	const { data: details }: any = useGetInterventionDetailQuery(
		interventionId || '',
		{
			refetchOnMountOrArgChange: true,
		}
	);
	return (
		<>
			<Box sx={{ width: '100%' }}>
				<Box>
					<Typography variant='h4'>
						{t('drawerListItems.editIntervention')}
					</Typography>
					<Card sx={{ marginTop: 3 }}>
						<CardContent sx={{ padding: '24px' }}>
							<Box
								display='flex'
								justifyContent='space-between'
								marginBottom={2}
							>
								<Typography variant='body1' sx={{ fontWeight: 'bold' }}>
									{t('member.personalInformation')}
								</Typography>
							</Box>
							<Grid container spacing={3} marginTop={0}>
								<Grid size={6}>
									<AppFieldView
										label={t('member.fileNo')}
										value={details?.data.fileNo}
									/>
								</Grid>
								<Grid size={6}>
									<AppFieldView
										label={t('preAdmission.unit')}
										value={details?.data.branchName}
									/>
								</Grid>
								<Grid size={6}>
									<AppFieldView
										label={t('preAdmission.name_en')}
										value={details?.data.nameEn}
									/>
								</Grid>
								<Grid size={6}>
									<AppFieldView
										label={t('preAdmission.name_zh')}
										value={details?.data.nameZh}
									/>
								</Grid>
							</Grid>
						</CardContent>
					</Card>
					<Card sx={{ marginTop: 3 }}>
						<InterventionForm
							type={type}
							setType={setType}
							editType={'note'}
							details={details}
						/>
					</Card>
				</Box>
			</Box>
		</>
	);
}
